import intlTelInput from "intl-tel-input";
import IMask from "imask";
import "../helpers/utils.js";

const inputs = document.querySelectorAll('[type="tel"]');

let iti;

if (inputs) {
  inputs.forEach((input) => {
    input.placeholder = "___ ___ ____";

    const maskOptions = {
      mask: "000 000 000 0000",
      lazy: true,
    };

    IMask(input, maskOptions);

    iti = intlTelInput(input, {
      initialCountry: "auto",
      geoIpLookup: (callback) => {
        fetch("https://ipapi.co/json")
          .then((res) => res.json())
          .then((data) => callback(data.country_code))
          .catch(() => callback("uk"));
      },
    });
  });
}

export function getIti() {
  return iti;
}
